import React from 'react'
import { VuiToggleInput } from '@topkamera/viso-ui'
import './NotificationUnreadToggle.scss'

const NotificationUnreadToggle = ({
  unreadOnly, toggleUnreadOnly
}) => {

  return (
    <div className='viso-notification-unread-toggle'>
      <label>
        <VuiToggleInput
          checked={unreadOnly}
          reversed
          onChange={toggleUnreadOnly}
          value='unreadOnly'
          id='unreadOnly'
          label='Unread only'
        />
      </label>
    </div>
  )
}

export default NotificationUnreadToggle